import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";
import 'firebase/messaging';
import 'firebase/performance'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCG8G5v2CD6RESAuvePVvvs_xE5d6_uX_w",
  authDomain: "canopy-caricode.firebaseapp.com",
  databaseURL: "https://canopy-caricode.firebaseio.com",
  projectId: "canopy-caricode",
  storageBucket: "canopy-caricode.appspot.com",
  messagingSenderId: "165538674924",
  appId: "1:165538674924:web:d3ced5e3454156ef2dcdc9"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore();
firebase.functions();
firebase.messaging();
firebase.performance();
firebase.firestore().enablePersistence();

export default firebase;
